import React, { useState } from 'react';
import api from '../../api';

export default function ImageUploader({ 
  onUploadSuccess, 
  onUploadError, 
  accept = 'image/*,video/*',
  label = 'Upload Image'
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleUpload = async (file) => {
    setIsUploading(true);
    setProgress(0);
    
    try {
      const form = new FormData();
      form.append('file', file);
      
      const response = await api.post('/api/admin/events/upload-image', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      });
      
      if (onUploadSuccess) onUploadSuccess(response.data);
    } catch (error) {
      if (onUploadError) onUploadError(error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="image-uploader">
      <label className="upload-label">
        <input
          type="file"
          accept={accept}
          onChange={(e) => {
            if (e.target.files[0]) {
              handleUpload(e.target.files[0]);
            }
          }}
          disabled={isUploading}
        />
        {isUploading ? (
          <>
            <div className="upload-progress">
              <div 
                className="progress-bar"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="upload-status">Uploading... {progress}%</p>
          </>
        ) : (
          <>
            <span className="upload-icon">📎</span>
            <span>{label}</span>
          </>
        )}
      </label>
    </div>
  );
}